import React, { Component } from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { green, maxwidth, pink } from '../../constants'
import Youtubeplayer from '../Youtubeplayer/Youtubeplayer'
import './Introduction.css'


export default function Introduction() {

  const handleclick = () => {
    const link = "https://drive.google.com/file/d/1mGRQrUTFj_izM6_6yeiggS_GdkKPRvMm/view?usp=sharing";
    window.open(link, '_blank', 'noreferrer');
}
  return (

    <div  className='intro-container'>
      <div className='intro-subone'>
      
          <p className='title'>What We Do:</p>

      
        <p className='introtext' style={{marginBottom:"0px"}}>Women's marginalisation is pervasive across our society. But the
          situation is even more gruesome for rural women in terms of
          literacy, health, hygiene, self-defence, and independence. Empower
          Bharat developed a unique platform called <span style={{ color: pink,fontWeight:"normal" }}>"STREE" - Safety Training for Rural Equality and Empowerment.</span> where rural
          women and girl children can receive all safety training at one place.
          Additionally, this platform gives women's organisations/ groups the
          opportunity to market their handmade goods and gain financial
          independence.</p>

          <button onClick={handleclick} className='readmore'> 
          <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
          <p className='readmore-para'>Read more</p>
          <FaArrowRight style={{color:pink,marginRight:"10px"}}></FaArrowRight>
          </div></button>
      </div>
      <div className='intro-subone'>
        <Youtubeplayer embedId="_XBVCWv_0dI" />
      </div>
    </div>

  );
}


